import { Action, createReducer, on } from '@ngrx/store';
import {
  restoreCustomerRequest,
  restoreCustomerSuccess,
  restoreCustomerFailure,
  clearRestoreCustomerRequest
} from '../actions/restore-customer.actions';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

export const restoreCustomerFeatureKey = 'restoreCustomer';

export interface RestoreCustomerState {
  restoreCustomerRequest: string | undefined;
  restoreCustomerSuccess: string | undefined;
  restoreCustomerFailure: IGenericError<ErrorResponse> | undefined;
  loaded: boolean | undefined;
}

export const initialState: RestoreCustomerState = {
  restoreCustomerRequest: undefined,
  restoreCustomerSuccess: undefined,
  restoreCustomerFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(restoreCustomerRequest, (state, action) => ({
    ...state,
    restoreCustomerRequest: action.customerId
  })),
  on(restoreCustomerSuccess, (state, action) => ({
    ...state,
    restoreCustomerSuccess: action.response,
    loaded: true
  })),
  on(restoreCustomerFailure, (state, action) => ({
    ...state,
    restoreCustomerFailure: action.error
  })),
  on(clearRestoreCustomerRequest, (state) => ({
    ...state,
    restoreCustomerSuccess: undefined,
    loaded: false
  }))
);

export const restoreCustomerRequestState = (state: RestoreCustomerState) => state.restoreCustomerRequest;
export const restoreCustomerResponse = (state: RestoreCustomerState) => state.restoreCustomerSuccess;
export const restoreCustomerFailureState = (state: RestoreCustomerState) => state.restoreCustomerFailure;
export const getRestoreCustomerIsLoaded = (state: RestoreCustomerState) => state.loaded;
